import { EMAILS } from '../global/support/EMAILS';

const OOPS = 'Oops! Something went wrong.';

export const COPY_GENERIC = {
	AI_GENERATION_CONFIRMATION: (contentLabel: string, count: number) =>
		`Use Arovy AI to auto-generate the ${contentLabel} for all ${count} fields?`,
	AND_SPACED: ' and ',
	BUSINESS_CONTEXT_UPDATED_WITH_FILE: (fileName: string) =>
		`Business context updated with content from "${fileName}"`,
	BY_SPACED: ' by ',
	CANCEL: 'Cancel',
	CLICK_HERE_TO_VIEW: (target: string) => `Click here to view ${target}`,
	COLLAPSE: 'Collapse',
	COLLAPSE_ALL: 'Collapse All',
	CONFIGURE: (value: string) => `Configure ${value}`,
	CONFIRM: 'Confirm',
	CONTACT_SUPPORT: `${OOPS} If this persists, please contact ${EMAILS.SUPPORT} for more help.`,
	CONTACT_SUPPORT_WITH_MESSAGE: `Please contact ${EMAILS.SUPPORT} and provide the following error message:`,
	COULD_NOT_START_EXPORT: 'Could not Start Export',
	CREATE_NEW: (value: string) => `Create New ${value}`,
	DATA_DAYS_OLD: (days: number) => `Your data is ${days} days old.`,
	DAYS: (value: number) => (Math.abs(value) === 1 ? `${value} Day` : `${value} Days`),
	DISABLE: 'Disable',
	DISABLED: 'Disabled',
	DISMISS: 'Dismiss',
	DOWNLOAD_CSV: 'Download CSV',
	DURATION: 'Duration',
	ENABLED_COUNT: (enabled: number, total: number): string => `${enabled} of ${total} enabled`,
	END: 'End',
	ERROR: 'Error',
	EXPAND: 'Expand',
	EXPAND_ALL: 'Expand All',
	EXPORT_STARTED: 'Your export has started',
	FORCE_DISABLED: 'Force Disabled',
	FORCE_ENABLED: 'Force Enabled',
	FORGOT_PASSWORD_INSTRUCTIONS:
		'If we find your email, you will receive instructions on how to reset your password shortly.',
	FOUND: 'Found',
	FROM: 'From',
	IMPORT_FAILURE: 'Last sync failed to complete successfully.',
	IMPORT_FINISHED_ON: (date: string): string => `Finished running on ${date}.`,
	IMPORT_STARTED_ON: (date: string): string => `Started running on ${date}.`,
	IMPORT_SUCCESS: 'Last sync completed successfully.',
	INFO: 'Info',
	INFORMATION: 'Information',
	INVITE_SUBTEXT: (email: string): string =>
		// eslint-disable-next-line max-len
		`Press the link below to copy the Invitation link to your clipboard, or press Resend Email to resend the invitation email to ${email}.`,
	IN_PROGRESS: 'In Progress',
	LAST_UPDATED: (date: string) => `Last Updated: ${date}`,
	LAYOUT_ENGINE_MS: (durationMs: number) => `Layout Engine: ${durationMs.toFixed(1)}ms`,
	LOG_FOR_SYNC: (status: string) => `Log for ${status} Sync`,
	MAX_FILE_SIZE_EXCEEDED: 'Max file size exceeded',
	NAME_YOUR: (value: string) => `Name Your ${value}`,
	NO_ACCESS_COMPARISON_DATA: (accessNames: Array<string>) => {
		if (accessNames.length === 0) {
			return 'No object or field access has been granted.';
		}

		if (accessNames.length === 1) {
			return `No object or field access has been granted to ${accessNames[ 0 ]}.`;
		}

		return `No object or field access has been granted to ${accessNames.join(' or ')}.`;
	},
	NO_ACCESS_EXPLAINER_DATA: (accessName: string) => {
		if (!accessName) {
			return 'No object or field access has been granted.';
		}

		return `No object or field access has been granted to ${accessName}.`;
	},
	ORGANIZE_BY: (value: string) => `Organize by ${value}`,
	PASSWORD_MESSAGE: (passwordFieldName: string): string => `Please enter a valid ${passwordFieldName}`,
	PERCENTAGE: (value: number) => `${value}%`,
	PROCESSING_BACKGROUND_MESSAGE: (
		estimatedTime: string,
		fieldsToProcess: number
	) => {
		const fieldText = fieldsToProcess === 1 ? 'field' : 'fields';

		return `This will take approximately ${estimatedTime} for ${fieldsToProcess} ${fieldText} metadata updates.
			You can close this modal and continue working.
			You'll receive a notification when your Data Dictionary is ready.`;
	},
	PROCESSING_FIELDS: (totalUpdates: number, totalSkipped: number, selectedRows: number) => {
		if (totalSkipped === 0) {
			return `Processing ${totalUpdates} field metadata updates across ${selectedRows} fields.`;
		}

		return `Processing ${totalUpdates} field metadata updates across ${selectedRows} fields.
		${totalSkipped} updates skipped where metadata is already populated.`;
	},
	SAVE: 'Save',
	SCHEDULE: 'Schedule',
	SELECT: (target: string) => `Select ${target}`,
	SHOW_ALL: 'Show All',
	SHOW_HIDDEN: 'Show Hidden',
	SHOW_INACTIVE: 'Show Inactive',
	SHOW_LESS: 'Show Less',
	SHOW_MORE: 'Show More',
	START: 'Start',
	SUCCESS: 'Success',
	SUCCESS_CONNECT_INTEGRATION_OAUTH: (name: string): string => `We're now connected to ${name}.`,
	SUCCESS_DISCONNECT_INTEGRATION_OAUTH: (name: string): string => `We're now disconnected from ${name}.`,
	SYNC_IN_PROGRESS: 'Sync currently in progress...',
	TO: 'To',
	TOO_MANY_EXPORTS: 'Too many exports in progress. Please try again later.',
	UNHANDLED_ERROR: OOPS,
	UNSET: 'Unset',
	WHEN_EXPORT_COMPLETES: `When the export completes,
	you will receive a notification and an email with a link to download the exported data.`
};
